export const SORT_TYPE = {
    GAME_TITLE: 'GAME_TITLE',
    MOST_RECENT: 'MOST_RECENT',
    UNPAID_TO_PAID: 'UNPAID_TO_PAID',
    PAID_TO_UNPAID: 'PAID_TO_UNPAID'
};
